import { graphql } from '~/gql';

export const ME_QUERY = graphql(`
  query Me {
    me {
      id
      email
      name
      role
      expert {
        avatarUrl
        hourlyRate
        depositionHourlyRate
        examinationHourlyRate
        recordsReviewHourlyRate
        testimonyHourlyRate
        stripeConnectAccountId
        stripeConnectOnboarded
      }
    }
  }
`);
